import { render, staticRenderFns } from "./androidaccess.vue?vue&type=template&id=4c07b108&scoped=true&"
import script from "./androidaccess.vue?vue&type=script&lang=js&"
export * from "./androidaccess.vue?vue&type=script&lang=js&"
import style0 from "./androidaccess.vue?vue&type=style&index=0&id=4c07b108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07b108",
  null
  
)

export default component.exports